import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Chart from 'chart.js/auto';
import './ReportPage.css';

function SenderDomainAnalysis() {
  const [data, setData] = useState([]);
  const { companyID, domain } = useParams();

  useEffect(() => {
    if (companyID && domain) {
      loadDomainAnalysis(companyID, domain);
    }
  }, [companyID, domain]);

  const loadDomainAnalysis = async (companyID, domain) => {
    try {
      const response = await fetch(`/sender-domain-analysis`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ companyID, domain })
      });
      if (!response.ok) throw new Error('Failed to load domain analysis.');
      const data = await response.json();
      setData(data);
      displayChart(data);
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error loading the domain analysis.');
    }
  };

  const displayChart = (data) => {
    const ctx = document.getElementById('domain-analysis-chart').getContext('2d');
    // Add chart.js logic here
  };

  return (
    <div>
      <h1>Sender Domain Analysis</h1>
      <canvas id="domain-analysis-chart"></canvas>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Timestamp</th>
            <th>User Email</th>
            <th>Sender Email</th>
            <th>Sender Domain</th>
            <th>Classification</th>
            <th>Certainty</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.id}</td>
              <td>{new Date(row.timestamp).toLocaleString()}</td>
              <td>{row.emailAddress}</td>
              <td>{row.senderEmail}</td>
              <td>{row.senderDomain}</td>
              <td>{row.classification}</td>
              <td>{row.certainty.toFixed(2)}</td>
              <td>{row.details}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SenderDomainAnalysis;
